import type { BillingMoney } from '@/types/billing'

/** Display only: the integer stays a string everywhere else. Costs (scale 9)
 *  show up to four decimals, so a fraction of a cent is still visible. */
export function formatMoney(money: BillingMoney | null | undefined, locale: string): string {
  if (!money) return '—'
  const value = Number(money.amount_units) / 10 ** money.scale
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: money.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: money.scale > 2 ? 4 : 2,
  }).format(value)
}

export function formatMinor(units: string | number, currency: string, locale: string): string {
  return formatMoney({ amount_units: String(units), currency, scale: 2 }, locale)
}
